import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { IBrand } from "../utils/types";

export const updateBrands = async (brands: IBrand[], uid: string) => {
    const userRef = doc(db, "users", uid || "");
    const userSnap = await getDoc(userRef);
    const userData = userSnap.data();
    const personaId = userData?.personaId;
    const selectedBrandNames = [];

    if (personaId) {
        const personaRef = doc(db, "personas", personaId || "");
        const personaSnap = await getDoc(personaRef);
        const personaData = personaSnap.data();

        for (let i = 0; i < brands.length; i++) {
            const brand = brands[i];

            if (personaData?.brands.includes(brand.name)) {
                brand.isSelected = true;
                selectedBrandNames.push(brand.name);
            };
        }
    }

    return {
        updatedBrands: brands,
        updatedBrandNames: selectedBrandNames
    };
}